import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SearchType } from '@freelancer/search-filters';
import { PictureDisplay } from '@freelancer/ui/picture';

@Component({
  standalone: false,
  selector: 'app-search-empty-view',
  template: `
    <div class="EmptyViewContainer">
      <fl-picture
        class="mb-small"
        alt="Nothing found - sad face"
        i18n-alt="Alt text for search page empty state"
        [src]="
          searchType === SearchType.CHALLENGES
            ? 'search/innovation-challenges-empty-or-error-state.svg'
            : 'search/empty-or-error-state.svg'
        "
        [alignCenter]="true"
        [display]="PictureDisplay.BLOCK"
      ></fl-picture>
      @if (
        isBookmarksView &&
        (searchType === SearchType.PROJECTS ||
          searchType === SearchType.CONTESTS)
      ) {
        @if (searchType === SearchType.PROJECTS) {
          <p
            class="text-center font-bold mb-xxsmall"
            i18n="Empty state header text"
          >
            You have no bookmarked projects yet.
          </p>
          <p
            class="text-center"
            i18n="Empty state subheader text"
          >
            Search through our projects directory and click on the bookmark tag
            to save for later.
          </p>
        }
        @if (searchType === SearchType.CONTESTS) {
          <p
            class="text-center font-bold mb-xxsmall"
            i18n="Empty state header text"
          >
            You have no bookmarked contests yet.
          </p>
          <p
            class="text-center"
            i18n="Empty state subheader text"
          >
            Search through our contests directory and click on the bookmark tag
            to save for later.
          </p>
        }
      } @else {
        <p
          class="text-center font-bold mb-xxsmall"
          i18n="Empty state header text"
        >
          No results matched your search
        </p>
        <p
          class="text-center"
          i18n="Empty state subheader text"
        >
          Try a different search for better results
        </p>
      }
    </div>
  `,
  styleUrls: ['./search-empty-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchEmptyViewComponent {
  PictureDisplay = PictureDisplay;
  SearchType = SearchType;

  @Input() isBookmarksView = false;
  @Input() searchType?: SearchType;
}
